<script>
import {linkProps} from './index.js'

const linkTypeMap = {
  push: {},
  replace: {replace: true},
  append: {append: true},
  blank: {target: '_blank'}
}

export default {
  name: 'sy-link',
  props: linkProps,
  computed: {
    params () {
      const {to} = this.$attrs

      if (typeof to === 'string') {
        return {to}
      }

      const {type = 'push', tag, ...rest} = to
      const linkParams = linkTypeMap[type] || {}
      return {
        to: rest,
        ...linkParams
      }
    }
  },
  render (h) {
    const {params, $slots, $attrs} = this
    const {to, ...attrs} = $attrs
    return (
      <router-link
        class="font-color-link"
        props={{
          ...params,
          ...attrs
        }}
        attrs={params}
      >
        {
          $slots.default
        }
      </router-link>
    )
  }
}
</script>

<style scoped lang="scss">

</style>